/**
 * Aggiunge classe 'os-scrolled' al body quando lo scroll supera la soglia definita
 */
(function() {
  const osScrollThreshold = 100; // Soglia in pixel
  const osScrolledClass = 'os-scrolled';
  let osLastScrollPosition = 0;
  let osTicking = false;

  function osUpdateScrollClass(scrollPosition) {
    if (scrollPosition > osScrollThreshold) {
      document.body.classList.add(osScrolledClass);
    } else {
      document.body.classList.remove(osScrolledClass);
    }
  }

  function osHandleScroll() {
    osLastScrollPosition = window.scrollY;

    if (!osTicking) {
      window.requestAnimationFrame(function() {
        osUpdateScrollClass(osLastScrollPosition);
        osTicking = false;
      });
      osTicking = true;
    }
  }

  // Inizializza al caricamento
  osUpdateScrollClass(window.scrollY);
  
  // Listener per lo scroll
  window.addEventListener('scroll', osHandleScroll, { passive: true });
})();